var swiper = new Swiper(".customer-result-swiper", {
  slidesPerView: 3,
  loop: true,
  navigation: {
    nextEl: ".swiper-btn-next",
    prevEl: ".swiper-btn-prev",
  },
  breakpoints: {
    1025: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
    640: {
      slidesPerView: 3,
      spaceBetween: 15,
    },
    424: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    0: {
      slidesPerView: 1,
      spaceBetween: 15,
    }
  },
});

document.addEventListener("DOMContentLoaded", function() {
  function openTab(evt, tabName) {
    var i, tablinks, slideCards;

    slideCards = document.getElementsByClassName("swiper-card");
    for (i = 0; i < slideCards.length; i++) {
      slideCards[i].style.display = "none";
    }

    tablinks = document.getElementsByClassName("tablinks");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "");
    }

    if (tabName === "all") {
      for (i = 0; i < slideCards.length; i++) {
        slideCards[i].style.display = "block";
      }
    } else {
      for (i = 0; i < slideCards.length; i++) {
        if (slideCards[i].getAttribute("id") === tabName) {
          slideCards[i].style.display = "block";
          console.log("tabName" , tabName)
        }
      }
    }

    evt.currentTarget.className += " active";
  }

  // Check if there are tablinks
  var tabButtons = document.getElementsByClassName("tablinks");
  if (tabButtons.length > 0) {
    // Set default open tab
    var defaultOpenElement = document.getElementById("defaultOpen");
    if (defaultOpenElement) {
      defaultOpenElement.click();
    }

    // Add event listeners to the tab buttons
    for (var i = 0; i < tabButtons.length; i++) {
      tabButtons[i].addEventListener("click", function(evt) {
        var tabName = this.getAttribute("data-val");
        openTab(evt, tabName);
      });
    }

    var dropdowns = document.getElementsByClassName("dropdown");
    var dropdownButton = document.querySelector('.dropbtn');
    var tabs = document.querySelectorAll('.tablinks');
    var firstItem = tabs[0];
    var selectedText = firstItem.textContent;
    dropdownButton.textContent = selectedText;

    tabs.forEach(item => {
      item.addEventListener('click', function() {
        const selectedText = item.textContent;
        dropdownButton.textContent = selectedText;
      });
    });

    for (var i = 0; i < dropdowns.length; i++) {
      var dropdown = dropdowns[i];
      var dropdownContent = dropdown.getElementsByClassName("dropdown-content")[0];

      dropdown.getElementsByClassName("dropbtn")[0].addEventListener("click", function() {
        this.classList.toggle("active");
        dropdownContent.classList.toggle("show");
      });
    }

    window.addEventListener("click", function(event) {
      if (!event.target.matches('.dropbtn')) {
        var dropdowns = document.getElementsByClassName("dropdown-content");
        for (var i = 0; i < dropdowns.length; i++) {
          var openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
            openDropdown.previousElementSibling.classList.remove('active');
          }
        }
      }
    });
  } else {
   
    var slideCards = document.getElementsByClassName("swiper-card");
    for (var i = 0; i < slideCards.length; i++) {
      slideCards[i].style.display = "block";
    }
  }
});
